import React, { useEffect, useRef, useState } from 'react';
import { Table, Segment, Loader, Icon, Button } from 'semantic-ui-react';
import { DashChartProps } from '../DashCard';
import { useCentralCalls } from '@src/rest/CentralCalls';
import './Chart.css';

const NestedReport: React.FC<DashChartProps> = ({
    item, setChartData, projectVersionId, userId, projectId, filterParams,
}) => {
    // const [tableData, setTableData] = useState<Array<Record<string, any>> | null>(null);
    // const [filteredData, setFilteredData] = useState<Array<Record<string, any>> | null>(null);
    // const [loading, setLoading] = useState<boolean>(true);
    // const [filterState, setFilterState] = useState<Record<string, Set<string>>>({});
    // const [sortState, setSortState] = useState<Record<string, 'asc' | 'desc' | null>>({});
    // const [activeFilterColumn, setActiveFilterColumn] = useState<string | null>(null);
    // const filterRef = useRef<HTMLDivElement | null>(null);

    // const { executeStoredProcedure, getDashPivotTableData } = useCentralCalls();

//12533

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflow: 'auto' }}>
            <iframe 
                src={`https://nested-knowledge.com/embed/dashboard/${item.nestedReportId}`} 
                style={{ flexGrow: 1, width: '100%',  height: '100%',border: 'none' }} 
                allow="clipboard-read; clipboard-write" />
        </div>
    );
};

export default NestedReport;